const AuthRoutes = {
    path: '/auth',
    component: () => import('@/layouts/blank/AuthLayout.vue'),
    meta: {
        requiresAuth: false
    },
    children: [
        {
            name: 'login',
            path: '/auth/login',
            component: () => import('@/views/authentication/BoxedLogin.vue')
        },
        {
            name: 'Side Register',
            path: '/auth/register',
            component: () => import('@/views/authentication/BoxedRegister.vue')
        },
        {
            name: 'Boxed Forgot Password',
            path: '/auth/forgot-password',
            component: () => import('@/views/authentication/ForgotPassword.vue')
        },
        {
            name: 'Boxed Reset Password',
            path: '/auth/reset-password',
            component: () => import('@/views/authentication/ResetPassword.vue')
        },
        {
            name: 'Verify Email',
            path: '/auth/verify-email',
            component: () => import('@/views/authentication/VerifyEmail.vue')
        },
        {
            name: 'Error',
            path: '/auth/404',
            component: () => import('@/views/authentication/Error.vue')
        },
       {
            name: 'Error 500',
            path: '/errors/500',
            component: () => import('@/views/Error500.vue')
       },
      
    ]
};

export default AuthRoutes;
